import { TFunction } from 'i18next';
import { bool } from 'yup';

const make = (t: TFunction) =>
  bool().oneOf([true], t('termsAgreementIsRequired'));

export { make };
